import { gql } from "@apollo/client";

export const APPRAISAL = gql`
  mutation appraisal($input: appraisalInput) {
    appraisal(input: $input)
  }
`;
